import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'


import {IUseMObywatelPageLogicReturnProps} from '../MObywatelIdentityPageProps'
import mObywatelService from '../../../service/MObywatelService'
import {DateTime} from 'luxon'
import {SessionStorage} from '../../../common/cookie-storage'
import {AppState} from '../../../store'
import {STORAGEKEYS} from '../../../common/keys'


/**
 * Hook z logiką obsługujący stronę z kodem mObywatela
 */
export const useMObywatelPageLogic = (): IUseMObywatelPageLogicReturnProps => {
    const sessionStorage = new SessionStorage()

    /** USE STATE
     * W momencie odświeżenia strony, sprawdzamy w zmiennej z sessionStorage date aktynoości kodu..
     * Jeśli takiej zmiennej nie ma jeszcze ustawionej, oznacza to pierwszy render strony i kod nie był pobrany.
     *
     */
    const [currentMObywatelCodeExpiredTime, setCurrentMObywatelCodeExpiredTime] = useState(() => {
        const expiredDate = sessionStorage.get(STORAGEKEYS.MOBYWATEL_CODE_EXPIRED_TIME);

        if (!expiredDate) {
            return;
        }
        return DateTime.fromISO(expiredDate);
    })

    /** USE STATE
     * W momencie odświeżenia strony, sprawdzamy czy w sessionStorage mamy zapisany aktualnie kod mObywatela.
     * Jeśli tak jest i jest ważny to ustawiamy ten kod. Jeśli jest on pusty, oznacza to że obecnie żaden kod mObywatela nie jest aktywny, więc zwracamy pusty string.
     *
     */
    const [currentMObywatelCode, setCurrentMObywatelCode] = useState(() => {
        const currentCode = sessionStorage.get(STORAGEKEYS.CURRENT_MOBYWATEL_CODE)
        return (currentCode && currentCode.trim().length !== 0) ? currentCode : ""
    })

    /** FUNKCJA
     * Funkcja pobierająca nowy kod mObywatela z Backendu, zapisująca go w sessionStorage
     * oraz startująca timer
     * @param hasFirstRender
     */
    const generateNewMObywatelCode = async () => {
        const newMObywatelCode = await mObywatelService.getMobywatelManualVerificationCode()
        sessionStorage.add(STORAGEKEYS.CURRENT_MOBYWATEL_CODE, newMObywatelCode.text)
        sessionStorage.add(STORAGEKEYS.MOBYWATEL_CODE_EXPIRED_TIME, newMObywatelCode.dateValidity)
        setCurrentMObywatelCode(newMObywatelCode.text)

        const date = DateTime.fromISO(newMObywatelCode.dateValidity)
        setCurrentMObywatelCodeExpiredTime(date)
        return newMObywatelCode
    }

    /** FUNKCJA
     * Funkcja pomocnicza uruchamiana po wykonaniu akcji w UI (naciśnięciu przycisku)
     * Pierwsze jej uruchomienie jest możliwe dopiero po wygaśnięciu kodu, pojawiającego się przy pierwszym renderze strony,
     */
    const regenerateMObywatelCode = (a: any) => {
        if (currentMObywatelCode.trim().length === 0 || currentMObywatelCodeExpiredTime === undefined
            || DateTime.now() > currentMObywatelCodeExpiredTime) {
            generateNewMObywatelCode()
        }
    }


    /** HOOK
     * Hook obsługujący pierwszy render strony, oraz odświeżanie strony.
     */
    useEffect(() => {
        const isFirstRender = Boolean(sessionStorage.get(STORAGEKEYS.MOBYWATEL_IS_AFTER_FIRST_RENDER) === 'true')
        if (isFirstRender) {
            sessionStorage.add(STORAGEKEYS.MOBYWATEL_IS_FIRST_RENDER, 'false');
        } else {
            sessionStorage.add(STORAGEKEYS.MOBYWATEL_IS_FIRST_RENDER, 'true');
            generateNewMObywatelCode()
                .then((value) => {
                });
        }
        return
    }, [])


    return {
        currentMObywatelCodeExpiredTime: currentMObywatelCodeExpiredTime,
        isMobywatelCodeActive: Boolean(currentMObywatelCode.trim().length),
        mObywatelCurrentlyActiveCode: currentMObywatelCode,
        regenerateMObywatelCode,
    };
};